module.exports = __webpack_public_path__ + "media/stockholm/subway_roof-6c48f308.jpg";